import globalTypes from "reducers/types/global";

export const types = {
    CREATE_THIRDPAYMENT_REQUEST: "discounts/CREATE_THIRDPAYMENT_REQUEST",
    CREATE_THIRDPAYMENT_SUCCESS: "discounts/CREATE_THIRDPAYMENT_SUCCESS",
    CREATE_THIRDPAYMENT_FAILURE: "discounts/CREATE_THIRDPAYMENT_FAILURE",
    SET_SUMMARY_THIRDPAYMENT: "discounts/SET_SUMMARY_THIRDPAYMENT",
    LOAD_LIST_REQUEST: "discounts/LOAD_LIST_REQUEST",
    LOAD_LIST_FAILURE: "discounts/LOAD_LIST_FAILURE",
    LOAD_LIST_SUCCESS: "discounts/LOAD_LIST_SUCCESS",
    LOAD_TRANSACTION_REQUEST: "discounts/LOAD_TRANSACTION_REQUEST",
    LOAD_TRANSACTION_SUCCESS: "discounts/LOAD_TRANSACTION_SUCCESS",
    LOAD_TRANSACTION_FAILURE: "discounts/LOAD_TRANSACTION_FAILURE",
    CLEAR_DATA: "discounts/CLEAR_DATA",
    SET_TYPEH: "discounts/SET_TYPEH",
    SET_TYPESU: "discounts/SET_TYPESU",
    DOWNLOAD_TRANSACTION_LINE_REQUEST: "discounts/DOWNLOAD_TRANSACTION_LINE_REQUEST",
    DOWNLOAD_TRANSACTION_LINE_FAILURE: "discounts/DOWNLOAD_TRANSACTION_LINE_FAILURE",
    DOWNLOAD_TRANSACTION_LINE_SUCCESS: "discounts/DOWNLOAD_TRANSACTION_LINE_SUCCESS",
    DOWNLOAD_LIST_REQUEST: "discounts/DOWNLOAD_LIST_REQUEST",
    DOWNLOAD_LIST_FAILURE: "discounts/DOWNLOAD_LIST_FAILURE",
    DOWNLOAD_LIST_SUCCESS: "discounts/DOWNLOAD_LIST_SUCCESS",

    DOWNLOAD_FILE_ECHEQ_DETAIL_REQUEST: "/discounts/DOWNLOAD_FILE_ECHEQ_DETAIL_REQUEST",
    DOWNLOAD_FILE_ECHEQ_DETAIL_FAILURE: "/discounts/DOWNLOAD_FILE_ECHEQ_DETAIL_FAILURE",
    DOWNLOAD_FILE_ECHEQ_DETAIL_SUCCESS: "/discounts/DOWNLOAD_FILE_ECHEQ_DETAIL_SUCCESS",

    DOWNLOAD_FILE_ECHEQ_BATCH_REQUEST: "/discounts/DOWNLOAD_FILE_ECHEQ_BATCH_REQUEST",
    DOWNLOAD_FILE_ECHEQ_BATCH_FAILURE: "/discounts/DOWNLOAD_FILE_ECHEQ_BATCH_FAILURE",
    DOWNLOAD_FILE_ECHEQ_BATCH_SUCCESS: "/discounts/DOWNLOAD_FILE_ECHEQ_BATCH_SUCCESS",

    DOWNLOAD_TRANSACTION_FILE_REQUEST: "discounts/DOWNLOAD_TRANSACTION_FILE_REQUEST",
    DOWNLOAD_TRANSACTION_FILE_FAILURE: "discounts/DOWNLOAD_TRANSACTION_FILE_FAILURE",
    DOWNLOAD_TRANSACTION_FILE_SUCCESS: "discounts/DOWNLOAD_TRANSACTION_FILE_SUCCESS",
    DOWNLOAD_CONFIRMATION_REQUEST: "discounts/DOWNLOAD_CONFIRMATION_REQUEST",
    DOWNLOAD_CONFIRMATION_FAILURE: "discounts/DOWNLOAD_CONFIRMATION_FAILURE",
    DOWNLOAD_CONFIRMATION_SUCCESS: "discounts/DOWNLOAD_CONFIRMATION_SUCCESS",
    SET_PAGE_TO_GO_BACK: "discounts/SET_PAGE_TO_GO_BACK",
    THIRDPAYMENT_TICKET_SUCCESS: "discounts/THIRDPAYMENT_TICKET_SUCCESS",
    CLEAN_THIRDPAYMENT_TICKET: "discounts/CLEAN_THIRDPAYMENT_TICKET",

    LOAD_LIST_ECHEQ_LOT_REQUEST: "discounts/LOAD_LIST_ECHEQ_LOT_REQUEST",
    LOAD_LIST_ECHEQ_LOT_FAILURE: "discounts/LOAD_LIST_ECHEQ_LOT_FAILURE",
    LOAD_LIST_ECHEQ_LOT_SUCCESS: "discounts/LOAD_LIST_ECHEQ_LOT_SUCCESS",

    DOWNLOAD_DOCUMENT_REQUEST: "discounts/DOWNLOAD_DOCUMENT_REQUEST",
    DOWNLOAD_DOCUMENT_FAILURE: "discounts/DOWNLOAD_DOCUMENT_FAILURE",
    DOWNLOAD_DOCUMENT_SUCCESS: "discounts/DOWNLOAD_DOCUMENT_SUCCESS",

    SET_DISCOUNT_STATUS: "discounts/SET_DISCOUNT_STATUS",
    RESTART_DISCOUNT_STATUS: "discounts/RESTART_DISCOUNT_STATUS",
    RESET_ECHEQ_FILTERS: "discounts/RESET_ECHEQ_FILTERS",
    SET_ECHEQ_FILTERS: "discounts/SET_ECHEQ_FILTERS",

    LOAD_LIST_ECHEQ_REQUEST: "discounts/LOAD_LIST_ECHEQ_REQUEST",
    LOAD_LIST_ECHEQ_FAILURE: "discounts/LOAD_LIST_ECHEQ_FAILURE",
    LOAD_LIST_ECHEQ_SUCCESS: "discounts/LOAD_LIST_ECHEQ_SUCCESS",

    LOAD_DISCOUNT_SIMULATION_REQUEST: "discounts/LOAD_DISCOUNT_SIMULATION_REQUEST",
    LOAD_DISCOUNT_SIMULATION_FAILURE: "discounts/LOAD_DISCOUNT_SIMULATION_FAILURE",
    LOAD_DISCOUNT_SIMULATION_SUCCESS: "discounts/LOAD_DISCOUNT_SIMULATION_SUCCESS",

    RESET_DISCOUNT_SIMULATION_STATUS: "discounts/RESET_DISCOUNT_SIMULATION_STATUS",

    DISCOUNT_REQUIRED_CREDENTIALS_REQUEST: "discounts/DISCOUNT_REQUIRED_CREDENTIALS_REQUEST",
    DISCOUNT_REQUIRED_CREDENTIALS_FAILURE: "discounts/DISCOUNT_REQUIRED_CREDENTIALS_FAILURE",
    DISCOUNT_REQUIRED_CREDENTIALS_SUCCESS: "discounts/DISCOUNT_REQUIRED_CREDENTIALS_SUCCESS",

    NEW_DISCOUNT_TICKET_REQUEST: "discounts/NEW_DISCOUNT_TICKET_REQUEST",
    NEW_DISCOUNT_TICKET_FAILURE: "discounts/NEW_DISCOUNT_TICKET_FAILURE",
    NEW_DISCOUNT_TICKET_SUCCESS: "discounts/NEW_DISCOUNT_TICKET_SUCCESS",

    CLEAN_DISCOUNT_TICKET: "discounts/CLEAN_DISCOUNT_TICKET",

    SET_DISCOUNT_FILTERS: "discounts/SET_DISCOUNT_FILTERS",

    GET_PARTIAL_ECHEQS_REQUEST: "discounts/GET_PARTIAL_ECHEQS_REQUEST",
    GET_PARTIAL_ECHEQS_FAILURE: "discounts/GET_PARTIAL_ECHEQS_FAILURE",
    GET_PARTIAL_ECHEQS_SUCCESS: "discounts/GET_PARTIAL_ECHEQS_SUCCESS",

    SET_APPROVED_ECHEQS: "discounts/SET_APPROVED_ECHEQS",
    REFRESH_SESSION: "discounts/REFRESH_SESSION",

    SEND_TRANSACTION_TICKET_REQUEST: "discounts/SEND_TRANSACTION_TICKET_REQUEST",
    SEND_TRANSACTION_TICKET_FAILURE: "discounts/SEND_TRANSACTION_TICKET_FAILURE",
    SEND_TRANSACTION_TICKET_SUCCESS: "discounts/SEND_TRANSACTION_TICKET_SUCCESS",
};

export const INITIAL_STATE = {
    fetching: false,
    transactionsEcheqDiscount: [],
    echeqDocuments: [],
    dateFrom: null,
    dateTo: null,
    amountFrom: null,
    typeSelect: true,
    amountTo: null,
    status: "",
    idTransaction: "",
    fetchingDownload: false,
    discountsData: {},
    isFirstFetching: true,
    pageToGoBack: null,
    thirdPartiesTicket: { status: "", idTransaction: "" },

    discountStatus: "INITIAL",
    echeqFilters: {
        emitted: "",
        ownership: "TODOS",
        number: "",
        orderColumName: "fecha_pago",
        orderDirection: "ascendent",
        payedCheck: false,
        emitedEcheq: true,
        status: "TODOS",
        option: "received.echeqs",
        // createdFrom: date7DaysBefore,
        // createdTo: today,
        createdFrom: null,
        createdTo: null,

        receiver: "",
        // payedFrom: today,
        // payedTo: date7DaysAfter,
        payedFrom: null,
        payedTo: null,
        amountFrom: null,
        amountTo: null,
        discountEcheqType: "",
    },
    listEcheqResponse: {},
    listEcheq: [],
    hasPartials: false,
    newDiscount: {
        echeqList: [],
        account: {
            productType: "",
            idProduct: "",
        },
        isOwnEcheq: false,
    },
    discountSimulation: {
        totalAmount: {
            quantity: 0,
            currency: "",
        },
        totalEffectiveAmount: {
            quantity: 0,
            currency: "",
        },
        idBatch: null,
        echeqs: [],
        iibb: [],
    },
    idTransactionSimulate: "",
    discountSimulationStatus: "INITIAL",
    fetchingSimulation: false,
    discountRequiredCredentials: [],
    discountTicket: { status: "", idTransaction: "" },
    discountTicketSignable: true,

    discountFilters: {
        dateFrom: null,
        dateTo: null,
        status: "",
        idBatch: "",
    },
    negotiatePartial: {
        echeqs: [],
        totalAmount: null,
        totalEffectiveAmount: null,
    },

    approvedEcheqs: [],

    echeqPagination: {},
    hasMoreData: false,
    lotType: null,
    transactionTicket: null,
};

export default (state = INITIAL_STATE, action = {}) => {
    const {
        discountsData,
        summary,
        signatures,
        pendingDispatch,
        idTransactionStatus,
        modificationDateTime,
        userEditorFullName,
        creatorFullName,
        creationDate,
        transactionsEcheqDiscount,
        echeqDocuments,
        idTransaction,
        idTransactionLot,
        pageToGoBack,
        thirdPartiesTicket,
        data,

        newDiscountStatus,
        avoidRestartStatus,
        echeqFilters = {},
        listEcheqResponse,
        listEcheq,
        hasPartials,
        newDiscount,
        discountSimulation,
        idTransactionSimulate,
        discountRequiredCredentials,
        discountTicket,
        discountFilters = {},
        negotiatePartial,
        approvedEcheqs,

        pageNumber,
        totalPages,
        lotType,
    } = action;
    switch (action.type) {
        case types.CREATE_THIRDPAYMENT_REQUEST:
            return {
                ...state,
                fetching: true,
                summary,
            };
        case types.CLEAR_DATA:
            return {
                ...state,
                ...INITIAL_STATE,
                summary: {},
            };
        case types.SET_TYPEH:
            return {
                ...state,
                typeSelect: false,
                transactionsEcheqDiscount: [],
                echeqDocuments: [],
            };
        case types.SET_TYPESU:
            return {
                ...state,
                typeSelect: true,
                transactionsEcheqDiscount: [],
                echeqDocuments: [],
            };
        case types.CREATE_THIRDPAYMENT_SUCCESS:
            return {
                ...state,
                fetching: false,
                summary: {
                    ...state.summary,
                    signatures,
                    pendingDispatch,
                    idTransactionStatus,
                    modificationDateTime,
                    userEditorFullName,
                    creatorFullName,
                    creationDate,
                },
            };

        case types.CREATE_THIRDPAYMENT_FAILURE:
            return {
                ...state,
                fetching: false,
                summary,
            };
        case types.SET_SUMMARY_THIRDPAYMENT:
            return {
                ...state,
                discountsData,
            };

        case types.LOAD_LIST_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.LOAD_LIST_FAILURE:
            return {
                fetching: false,
            };
        case types.LOAD_LIST_SUCCESS:
            return {
                ...state,
                transactionsEcheqDiscount,
                fetching: false,
            };

        case types.LOAD_LIST_ECHEQ_LOT_REQUEST:
            return {
                ...state,
                ...idTransactionLot,
                fetching: true,
            };

        case types.LOAD_LIST_ECHEQ_LOT_SUCCESS:
            return {
                ...state,
                echeqDocuments,
                fetching: false,
            };

        case types.LOAD_LIST_ECHEQ_LOT_FAILURE:
            return {
                ...state,
                fetching: false,
            };

        case types.LOAD_TRANSACTION_REQUEST:
            return {
                ...state,
                idTransaction,
                fetching: true,
            };
        case types.LOAD_TRANSACTION_SUCCESS:
            return {
                ...state,
                fetching: false,
                transaction: {
                    ...data,
                },
            };
        case types.LOAD_TRANSACTION_FAILURE:
            return {
                ...state,
                fetching: true,
            };
        case types.DOWNLOAD_TRANSACTION_LINE_REQUEST:
            return {
                ...state,
            };
        case types.DOWNLOAD_TRANSACTION_LINE_FAILURE:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_TRANSACTION_LINE_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_TRANSACTION_FILE_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_TRANSACTION_FILE_FAILURE:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_TRANSACTION_FILE_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_LIST_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_LIST_FAILURE:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_LIST_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_CONFIRMATION_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_CONFIRMATION_FAILURE:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_CONFIRMATION_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.SET_PAGE_TO_GO_BACK:
            return {
                ...state,
                pageToGoBack,
            };
        case types.THIRDPAYMENT_TICKET_SUCCESS:
            return {
                ...state,
                thirdPartiesTicket,
            };
        case types.DOWNLOAD_DOCUMENT_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_DOCUMENT_FAILURE:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_DOCUMENT_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case globalTypes.RESET_SELECTED_ELEMENTS:
        case globalTypes.CLEAN_UP:
            return INITIAL_STATE;
        case types.CLEAN_THIRDPAYMENT_TICKET:
            return {
                ...state,
                thirdPartiesTicket: { status: "", idTransaction: "" },
            };

        case types.SET_DISCOUNT_STATUS:
            return {
                ...state,
                discountStatus: newDiscountStatus,
            };
        case types.RESTART_DISCOUNT_STATUS:
            return {
                ...state,
                discountStatus: avoidRestartStatus.includes(state.discountStatus) ? state.discountStatus : "INITIAL",
            };
        case types.RESET_ECHEQ_FILTERS:
            return {
                ...state,
                echeqFilters: {
                    ...INITIAL_STATE.echeqFilters,
                },
            };
        case types.SET_ECHEQ_FILTERS:
            return {
                ...state,
                echeqFilters: {
                    ...state.echeqFilters,
                    ...echeqFilters,
                },
            };

        case types.LOAD_LIST_ECHEQ_REQUEST:
            return {
                ...state,
                discountStatus: "CONFIG_DISCOUNT",
                fetching: true,
                discountSimulationStatus: "INITIAL",
            };
        case types.LOAD_LIST_ECHEQ_FAILURE:
            return {
                fetching: false,
                isFirstFetching: false,
            };
        case types.LOAD_LIST_ECHEQ_SUCCESS:
            return {
                ...state,
                listEcheqResponse,
                listEcheq,
                hasPartials,
                fetching: false,
                isFirstFetching: false,
                hasMoreData: pageNumber < totalPages,
                echeqPagination: { totalPages, pageNumber },
                lotType: null,
            };

        case types.LOAD_DISCOUNT_SIMULATION_REQUEST:
            return {
                ...state,
                newDiscount,
                fetchingSimulation: true,
                discountSimulationStatus: "INITIAL",
            };
        case types.LOAD_DISCOUNT_SIMULATION_FAILURE:
            return {
                ...state,
                fetchingSimulation: false,
                discountSimulationStatus: "FAILURE",
            };
        case types.LOAD_DISCOUNT_SIMULATION_SUCCESS:
            return {
                ...state,
                discountSimulation,
                fetchingSimulation: false,
                discountSimulationStatus: "SUCCESS",
                discountStatus: "SIMULATING_DISCOUNT",
                idTransactionSimulate,
            };

        case types.RESET_DISCOUNT_SIMULATION_STATUS:
            return {
                ...state,
                discountSimulationStatus: "INITIAL",
            };

        case types.DISCOUNT_REQUIRED_CREDENTIALS_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.DISCOUNT_REQUIRED_CREDENTIALS_FAILURE:
            return {
                fetching: false,
            };
        case types.DISCOUNT_REQUIRED_CREDENTIALS_SUCCESS:
            return {
                ...state,
                discountRequiredCredentials,
                fetching: false,
            };

        case types.NEW_DISCOUNT_TICKET_REQUEST:
            return {
                ...state,
                discountTicket: { status: "", idTransaction: "" },
            };
        case types.NEW_DISCOUNT_TICKET_SUCCESS:
            return {
                ...state,
                discountTicket,
                discountTicketSignable: discountTicket.status === "INVALID_CREDENTIAL",
            };
        case types.NEW_DISCOUNT_TICKET_FAILURE:
            return {
                ...state,
                discountTicket,
            };
        case types.CLEAN_DISCOUNT_TICKET:
            return {
                ...state,
                newDiscount: {
                    echeqList: [],
                    account: {
                        productType: "",
                        idProduct: "",
                    },
                },
                discountTicket: { status: "", idTransaction: "" },
                discountTicketSignable: true,
                newDiscountFormShouldShowLastValues: false,
            };

        case types.SET_DISCOUNT_FILTERS:
            return {
                ...state,
                discountFilters: {
                    ...state.discountFilters,
                    ...discountFilters,
                },
            };
        case types.DOWNLOAD_FILE_ECHEQ_DETAIL_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_FILE_ECHEQ_DETAIL_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_FILE_ECHEQ_DETAIL_FAILURE:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_FILE_ECHEQ_BATCH_REQUEST:
            return {
                ...state,
                fetchingDownload: true,
            };
        case types.DOWNLOAD_FILE_ECHEQ_BATCH_SUCCESS:
            return {
                ...state,
                fetchingDownload: false,
            };
        case types.DOWNLOAD_FILE_ECHEQ_BATCH_FAILURE:
            return {
                ...state,
                fetchingDownload: false,
            };

        case types.GET_PARTIAL_ECHEQS_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.GET_PARTIAL_ECHEQS_SUCCESS:
            return {
                ...state,
                fetching: false,
                negotiatePartial,
            };
        case types.GET_PARTIAL_ECHEQS_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        case types.SET_APPROVED_ECHEQS:
            return {
                ...state,
                approvedEcheqs,
                lotType,
            };
        case types.SEND_TRANSACTION_TICKET_REQUEST:
            return {
                ...state,
                fetching: true,
            };
        case types.SEND_TRANSACTION_TICKET_SUCCESS:
            return {
                ...state,
                fetching: false,
                transactionTicket: null,
            };
        case types.SEND_TRANSACTION_TICKET_FAILURE:
            return {
                ...state,
                fetching: false,
            };
        default:
            return state;
    }
};
export const actions = {
    validateThirdPay: (summary, formikBag, credentialType) => ({
        type: types.CREATE_THIRDPAYMENT_REQUEST,
        summary,
        formikBag,
        credentialType,
    }),
    clearData: () => ({
        type: types.CLEAR_DATA,
    }),
    setTypeH: () => ({
        type: types.SET_TYPEH,
    }),
    setTypeSU: () => ({
        type: types.SET_TYPESU,
    }),
    summaryThirdPay: (discountsData) => ({
        type: types.SET_SUMMARY_THIRDPAYMENT,
        discountsData,
    }),
    loadListDiscountRequest: () => ({
        type: types.LOAD_LIST_REQUEST,
    }),
    getTransaction: (idTransaction, getFileContest) => ({
        type: types.LOAD_TRANSACTION_REQUEST,
        idTransaction,
        getFileContest,
    }),
    downloadTransactionLines: (format, transactionLines) => ({
        type: types.DOWNLOAD_TRANSACTION_LINE_REQUEST,
        format,
        transactionLines,
    }),
    downloadListThirdPayment: (format, transactionsEcheqDiscount) => ({
        type: types.DOWNLOAD_LIST_REQUEST,
        format,
        transactionsEcheqDiscount,
    }),
    downloadFileTransaction: (
        format,
        transactionLines,
        typePayment,
        fileNam,
        id,
        reference,
        dateProcess,
        transactionOrder,
        currency,
        idTransactionStatus,
        accountName,
    ) => ({
        type: types.DOWNLOAD_TRANSACTION_FILE_REQUEST,
        format,
        transactionLines,
        typePayment,
        fileNam,
        id,
        reference,
        dateProcess,
        transactionOrder,
        currency,
        idTransactionStatus,
        accountName,
        isDetailDownload: true,
    }),
    downloadFileEcheqDetail: (idTransactionLot, echeqNumber, idBatch) => ({
        type: types.DOWNLOAD_FILE_ECHEQ_DETAIL_REQUEST,
        idTransactionLot,
        echeqNumber,
        idBatch,
    }),
    downloadFileEcheqBatch: (discountDetail) => ({
        type: types.DOWNLOAD_FILE_ECHEQ_BATCH_REQUEST,
        discountDetail,
    }),
    downloadFileTransactionItem: (
        format,
        typePayment,
        fileNam,
        id,
        reference,
        dateProcess,
        transactionOrder,
        currency,
        idTransactionStatus,
        accountName,
    ) => ({
        type: types.DOWNLOAD_TRANSACTION_FILE_REQUEST,
        format,
        transactionLines: null,
        typePayment,
        fileNam,
        id,
        reference,
        dateProcess,
        transactionOrder,
        currency,
        idTransactionStatus,
        accountName,
        isDetailDownload: false,
    }),
    downloadConfirmation: (summary) => ({
        type: types.DOWNLOAD_CONFIRMATION_REQUEST,
        summary,
    }),
    setPageToGoBack: (pageToGoBack) => ({
        type: types.SET_PAGE_TO_GO_BACK,
        pageToGoBack,
    }),
    cleanThirdPartiesTicket: () => ({
        type: types.CLEAN_THIRDPAYMENT_TICKET,
    }),
    downloadDocument: (fileId) => ({
        type: types.DOWNLOAD_DOCUMENT_REQUEST,
        fileId,
    }),

    setDiscountStatus: (newDiscountStatus) => ({
        type: types.SET_DISCOUNT_STATUS,
        newDiscountStatus,
    }),
    restartDiscountStatus: (...avoidRestartStatus) => ({
        type: types.RESTART_DISCOUNT_STATUS,
        avoidRestartStatus,
    }),
    resetEcheqFilters: () => ({
        type: types.RESET_ECHEQ_FILTERS,
    }),
    setEcheqFilters: (echeqFilters) => ({
        type: types.SET_ECHEQ_FILTERS,
        echeqFilters,
    }),
    loadListEcheqRequest: (params) => ({
        type: types.LOAD_LIST_ECHEQ_REQUEST,
        filterEmpty: params?.filterEmpty,
    }),
    loadDiscountSimulationRequest: (newDiscount) => ({
        type: types.LOAD_DISCOUNT_SIMULATION_REQUEST,
        newDiscount,
    }),
    resetDiscountSimulationStatus: () => ({
        type: types.RESET_DISCOUNT_SIMULATION_STATUS,
    }),
    fetchCredentialGroup: (params) => ({
        type: types.DISCOUNT_REQUIRED_CREDENTIALS_REQUEST,
        params,
    }),
    createDiscount: (params, formikBag, credential) => ({
        type: types.NEW_DISCOUNT_TICKET_REQUEST,
        params,
        formikBag,
        credential,
    }),
    cleanDiscountTicket: () => ({
        type: types.CLEAN_DISCOUNT_TICKET,
    }),
    loadListEcheqLotRequest: (idTransactionLot, echeqDocuments) => ({
        type: types.LOAD_LIST_ECHEQ_LOT_REQUEST,
        idTransactionLot,
        echeqDocuments,
    }),
    setDiscountFilters: (discountFilters) => ({
        type: types.SET_DISCOUNT_FILTERS,
        discountFilters,
    }),
    getPartialEcheqs: (idTransactionBatch) => ({
        type: types.GET_PARTIAL_ECHEQS_REQUEST,
        idTransactionBatch,
    }),
    setApprovedEcheqs: (approvedEcheqs, lotType) => ({
        type: types.SET_APPROVED_ECHEQS,
        approvedEcheqs,
        lotType,
    }),
    refreshSession: () => ({
        type: types.REFRESH_SESSION,
    }),
    sendTransactionTicket: (request) => ({
        type: types.SEND_TRANSACTION_TICKET_REQUEST,
        request,
    }),
};

export const selectors = {
    getFetching: ({ discounts }) => discounts.fetching,
    getTypePayment: ({ discounts }) => discounts.summary.typePayment,
    getCurrency: ({ discounts }) => discounts.summary.currency,
    getAmount: ({ discounts }) => discounts.summary.amount,
    getAccount: ({ discounts }) => discounts.summary.account,
    getDateProcess: ({ discounts }) => discounts.summary.dateProcess,
    getReferente: ({ discounts }) => discounts.summary.description,
    getTransaction: ({ discounts }) => discounts.transaction,
    getTransactionLinesStatus: ({ discounts }) => discounts.transactionsEcheqDiscount,
    getFile: ({ discounts }) => discounts.summary.file,
    getSummary: ({ discounts }) => discounts.summary,
    getTypeSelect: ({ discounts }) => discounts.typeSelect,
    getFetchingDownload: ({ discounts }) => discounts.fetchingDownload,
    isFirstFetching: ({ discounts }) => discounts.isFirstFetching,
    getPageToGoBack: ({ discounts }) => discounts.pageToGoBack,
    getApprovedEcheqs: ({ discounts }) => discounts.approvedEcheqs,
};
